import 'letteringjs';
import anime from 'animejs/lib/anime.es';
import { Controller, Scene } from 'scrollmagic';
import 'nodelist-foreach-polyfill';

function letterAnimate(letters) {
  anime.timeline({ loop: false })
    .add({
      targets: letters,
      translateX: [40, 0],
      translateZ: 0,
      opacity: [0, 1],
      easing: 'easeOutExpo',
      duration: 1200,
      delay(el, i, l) {
        return 500 + (700 * i) / (Math.max(l, 20));
      },
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const controller = new Controller();

  document.querySelectorAll('[data-split-text="true"]').forEach((splitItem) => {
    jQuery(splitItem).text((i, text) => text.trim()).lettering('words')
      .children('span')
      .lettering();

    splitItem.style.visibility = 'visible';

    const letterCollection = splitItem.querySelectorAll('span');
    const scene = new Scene({
      triggerElement: splitItem,
      triggerHook: 'onEnter',
      offset: Math.min(0.5 * splitItem.clientHeight, 200),
      reverse: false,
    });
    scene.addTo(controller);
    scene.on('enter', () => {
      letterAnimate(letterCollection);
    });
  });
});
